import templateUrl from 'servicestack/auto-query/auto-query-search-panel.htm';
import resolve from 'ioc/resolve';
import AutoQueryConfig from 'servicestack/auto-query/auto-query.config';
import basicController from 'servicestack/basic.controller.properties';

class AutoQuerySearchPanelController {
    constructor() {
        basicController(this)
    }
    isOneUp(){
        return resolve('$state').current.name === 'shop.product'; // hack
    }
    go(nav){
        if(this.isOneUp()) resolve('$state').transitionTo('shop.multi-view'); // TODO: hack
        nav.backToHere();
    }
}

const AutoQuerySearchPanelComponent  = {
    bindings: {
        panelType: '@',
        collapsed: '@',
        title: '@',
        query: '<'
    },
    controller: AutoQuerySearchPanelController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default AutoQuerySearchPanelComponent;